// removed by extract-text-webpack-plugin
module.exports = {"input":"input-37ZIx","disabled":"disabled-mP7SW","focus":"focus-2S2SW"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/form-controls/inputs/inputs.less
 ** module id = 167
 ** module chunks = 0
 **/